<template>
    <div class="icons-part">
        <shareIcon @click="copyShareUrl"><font-awesome-icon icon="fa-solid fa-copy" style="color: #909399" /></shareIcon>
        <shareIcon @click="copyShareWhatsappUrl"><font-awesome-icon icon="fa-brands fa-whatsapp" style="color: #909399" /></shareIcon>
        <shareIcon @click="facebookShare"><font-awesome-icon icon="fa-brands fa-square-facebook" style="color: #3c589b;" /></shareIcon>
        <shareIcon @click="pinteresShare"><font-awesome-icon icon="fa-brands fa-square-pinterest" style="color: #c7453c;" /></shareIcon>
        <shareIcon @click="stumbleuponShare"><font-awesome-icon icon="fa-brands fa-stumbleupon-circle" style="color: #ee4c2c;" /></shareIcon>
        <shareIcon @click="toggleSharePart"><font-awesome-icon icon="fa-regular fa-envelope" style="color: #79bbff" /></shareIcon>

        <el-dialog
                v-model="visible"
                title=""
                :width="dialogWidth"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                @closed="submitClose"
        >
            <div style="text-align: left">
                <div style="margin-bottom: 15px">
                    <span>{{i18n.tkey('lang_share_content')}}</span>
                    <el-input v-model="shareContent" :placeholder="i18n.tkey('lang_share_content')" clearable />
                </div>

                <div v-show="shareInfo.type == 'email'">
                    <span>{{i18n.tkey('lang_input_share_email_address')}}</span>
                    <el-input v-model="shareEmail" :placeholder="i18n.tkey('lang_email')" clearable />
                </div>

                <div style="text-align: center; margin-top: 20px;">
                    <el-button type="primary" @click="clickSubmit">{{i18n.tkey("lang_submit")}}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
    import shareIcon from "@/components/shopopee/common/shareIcon"
    import copy from "clipboard-copy"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCopy } from '@fortawesome/free-solid-svg-icons'
    import { faSquareFacebook, faSquarePinterest, faStumbleuponCircle } from '@fortawesome/free-brands-svg-icons'
    import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
    import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
    import util from "@/util/util";
    import myUtil from "@/util/util";
    import {inject, getCurrentInstance, onBeforeMount, ref, onMounted} from "vue";
    import shareApi from "@/request/shareApi";

    library.add(faSquareFacebook, faSquarePinterest, faStumbleuponCircle, faEnvelope, faCopy, faWhatsapp)

    const props = defineProps(["card"])

    const { proxy } = getCurrentInstance()
    const i18n = inject("i18n")

    const visible = ref(false)

    const cardObj = ref({})
    const dialogWidth = ref(475)

    const shareInfo = ref({})
    const shareContent = ref("")
    const shareEmail = ref("")

    function copyShareUrl(){
        copy(myUtil.generateCardShareUrl(props.card.id) + "&isAllow=1")
        util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function copyShareWhatsappUrl() {
        copy(myUtil.generateCardWhatsappShareUrl(props.card.id))
        util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function facebookShare(){
        // const titleStr = userInfoRef.value.name
        // const content = shareContent.value.trim()
        // const metaArr = [
        //     'og:url', encodeURIComponent(shareUrl.value),
        //     'og:title', titleStr,
        //     'og:description', content,
        //     'og:image', `${proxy.$ShopopeeUrl}/MPic/ZZ/${cardObj.value.cardinfo}`
        // ]
        // const metaParams = metaArr.toString()
        // // console.log(metaParams)
        // const shareStr = `${proxy.$ShopopeeUrl}/sharePage?mate=${encodeURIComponent(metaParams)}`
        // window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(shareStr)+'&t='+encodeURIComponent(document.title),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');

        shareInfo.value = {
            type: "facebook"
        }

        initShareInfo()
        visible.value = true
    }

    function pinteresShare(){
        // const titleStr = userInfoRef.value.name
        //
        // window.open('https://www.pinterest.com/pin/create/button/?url='+encodeURIComponent(shareUrl.value)+"&media="+encodeURIComponent(`${proxy.$ShopopeeUrl}/MPic/ZZ/${cardObj.value.cardinfo}`)+'&description='+titleStr,'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');

        shareInfo.value = {
            type: "pinteres"
        }

        initShareInfo()
        visible.value = true
    }

    function stumbleuponShare() {
        // const imgstr = `${proxy.$ShopopeeUrl}/MPic/ZZ/${cardObj.value.cardinfo}`
        //
        // const titleStr = userInfoRef.value.name
        //
        // window.open('https://www.stumbleupon.com/submit?url=' + encodeURIComponent(shareUrl) + '&title=' + titleStr + "&media=" + encodeURIComponent(imgstr), '_blank', 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');

        shareInfo.value = {
            type: "stumbleupon"
        }

        initShareInfo()
        visible.value = true

    }

    function toggleSharePart(){
        // receiveEmail.value = ""
        // showReceiveEmailInput.value = !showReceiveEmailInput.value

        shareInfo.value = {
            type: "email"
        }

        initShareInfo()
        visible.value = true
    }

    function clickSubmit() {
        if (myUtil.isEmpty(shareContent.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(shareEmail.value) && shareInfo.value.type == "email"){
            myUtil.alertWarning(i18n.tkey("lang_input_share_email_address"))
            return
        }

        const shareUrl = myUtil.generateCardShareUrl(cardObj.value.id)
        const cardImg = myUtil.generateCardImgUrl(cardObj.value.cardinfo)
        const titleStr = cardObj.value.name

        if (shareInfo.value.type == "facebook"){
            let metaArr = [
                'og:url', encodeURIComponent(shareUrl),
                'og:title', titleStr,
                'og:description', shareContent.value,
                'og:image', cardImg
            ]
            let metaParams = metaArr.toString()

            let shareStr = proxy.$ShopopeeUrl + 'sharePage?mate='+encodeURIComponent(metaParams)

            const url = 'http://www.facebook.com/sharer.php?u='+encodeURIComponent(shareStr)+'&t='+encodeURIComponent('3DShopopee') + '_blank' + 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350'

            if (myUtil.isMobile()){
                location.href = url
            }else{
                window.open(url)
            }

        }else if(shareInfo.value.type == "pinteres"){

            const url = 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(shareUrl) + "&media=" + encodeURIComponent(cardImg) + '&description='+titleStr  + encodeURIComponent(shareContent.value) + '_blank' + 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350'

            if (myUtil.isMobile()){
                location.href = url
            }else{
                window.open(url)
            }

        }else if(shareInfo.value.type == "stumbleupon"){

            const url = 'https://www.stumbleupon.com/submit?url=' + encodeURIComponent(shareUrl) + '&title=' + titleStr + "&media=" + encodeURIComponent(cardImg)+ '_blank'+ 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350'

            if (myUtil.isMobile()){
                location.href = url
            }else{
                window.open(url)
            }

        }else if(shareInfo.value.type == "email"){
            sendShareEmail()
        }

        myUtil.alertSuccess(i18n.tkey("lang_share_success"))
        visible.value = false

    }

    function submitClose(){
        // initShareInfo()
        shareInfo.value = {}
    }

    function initShareInfo(){
        shareContent.value = `${i18n.tkey("lang_share_Preset_content_1")} ${cardObj.value.name} ${i18n.tkey("lang_share_Preset_content_2")}`
        shareEmail.value = ""
    }

    function sendShareEmail(){
        const request = shareApi.sendMemberworkShareEmail
        const params = request.getParams()

        params.email = shareEmail.value
        params.url = myUtil.generateCardShareUrl(cardObj.value.id)
        params.content = shareContent.value
        params.img = myUtil.generateCardImgUrl(cardObj.value.cardinfo)

        request.send(params, () => {})
    }

    onBeforeMount(() => {
        if (null != props.card){
            cardObj.value = props.card
        }
    })

    onMounted(() => {
        if(myUtil.isMobile()){
            dialogWidth.value = "90%"
        }else{
            dialogWidth.value = "800px"
        }
    })

</script>

<style scoped>
    .icons-part {
        padding: 10px;
    }
</style>